import React, { useContext } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { SpinnerContext } from '../../../context/spinnerContext'
import { editManualPropertySchedule } from '../../../redux/slices/propertySlice'
import { scheduleCleningSchema } from '../../../util/validationSchema'
import { getISOToUTCDateFromTimestamp, getTimeStamp, isDateBefore, objectsAreEqual, getTimeZoneDifferenceMessage } from '../../../helper/function'
import { errorToast, successToast } from '../../../util/Toast/toast'
import CommonDateTimePicker from '../../commonDateTimePicker'

const EditScheduleCleaning = ({ toggleEditCleningModal, scheduleID, scheduledProperties, setIsRefresh, setCleaningScheduleRefersh }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)

  const updateDefualtValues = {
    booking_date_time: scheduledProperties?.booking_date_time ? getISOToUTCDateFromTimestamp(scheduledProperties?.booking_date_time) : null,
    next_checkin_time: scheduledProperties?.next_checkin_time ? getISOToUTCDateFromTimestamp(scheduledProperties?.next_checkin_time) : null
  }

  const methods = useForm({
    resolver: yupResolver(scheduleCleningSchema),
    mode: 'onBlur',
    defaultValues: updateDefualtValues
  })

  const {
    handleSubmit,
    control,
    trigger,
    watch,
    formState: { errors }
  } = methods

  console.log('errors', errors)
  const currentValue = watch()

  const hasChanged = objectsAreEqual(currentValue, updateDefualtValues) || Object.keys(errors)?.length !== 0

  const onSubmit = (data) => {
    setIsRefresh(false)

    const payload = {
      scheduleID: scheduleID,
      data: {
        ...data,
        booking_date_time: data?.booking_date_time ? getTimeStamp(data?.booking_date_time) : '',
        next_checkin_time: data?.next_checkin_time ? getTimeStamp(data?.next_checkin_time) : ''
      }
    }

    if (scheduleID) {
      changeLoader(true)
      dispatch(editManualPropertySchedule(payload))
        .then(({ payload }) => {
          if (payload?.status === 200) {
            changeLoader(false)
            toggleEditCleningModal()
            // toggleMoreDetailModal()
            setCleaningScheduleRefersh && setCleaningScheduleRefersh(true)
            setIsRefresh(true)
            successToast(payload?.data?.status_message || 'Success!')
          } else {
            errorToast(payload?.data?.status_message || 'Something went wrong')
            changeLoader(false)
          }
        })
        .catch(() => {
          changeLoader(false)
        })
    }
  }

  return (
    <div>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <div className="d-flex gap-2">
              <label className="form-control-label">Checkout At</label>
            </div>
            <div className="custom_date_picker_w100">
              <div>
                <CommonDateTimePicker
                  name="booking_date_time"
                  control={control}
                  placeholder="yyyy-MM-ddTHH:mm"
                  onDateChange={() => {
                    trigger('booking_date_time')
                  }}
                  shouldDisableDate={(date) => isDateBefore(date, new Date())}
                  // date only 14 able to select other date disable function need to find here...
                  // shouldDisableDate={(date) =>
                  //   isDateBefore(date, updateDefualtValues.booking_date_time) || isDateAfter(date, updateDefualtValues.booking_date_time)
                  // }
                  // disablePast={true}
                  slotActionBtn={['accept']}
                />
              </div>
            </div>
          </div>
          <div className="form-group mb-2">
            <label className="form-control-label">Checkin At</label>
            <div className="custom_date_picker_w100">
              <CommonDateTimePicker
                name="next_checkin_time"
                control={control}
                placeholder="yyyy-MM-ddTHH:mm A"
                onDateChange={() => {
                  trigger('next_checkin_time')
                }}
                shouldDisableDate={(date) => isDateBefore(date, updateDefualtValues.booking_date_time)}
              />
            </div>
          </div>
          <p
            className="fs-16 fw-400 red_color"
            dangerouslySetInnerHTML={{
              __html: getTimeZoneDifferenceMessage(scheduledProperties?.properties?.timezone)
            }}
          ></p>
          <div className="multi_btn_div mt-4">
            <button
              type="button"
              className="btn common-outline-btn w-100"
              onClick={() => {
                toggleEditCleningModal()
              }}
            >
              Close
            </button>
            <button type="submit" className="btn btn-primary common-field-btn w-100" disabled={hasChanged}>
              Update
            </button>
          </div>
        </form>
      </FormProvider>
    </div>
  )
}

export default EditScheduleCleaning
